import { IdentitySeason, IdentityTeam, IdentityUser } from '@reg/shared/model';

/**
 * Model to hold an assessor resource data from identity
 */
export class IdentityAssessor {
    public id: string = null;
    public season: IdentitySeason = new IdentitySeason();
    public teams: IdentityTeam[] = [];
    public user: IdentityUser = null;
    public userEmail: string = null;

    public clone(cloneUser: boolean = true): IdentityAssessor {
        const clone: IdentityAssessor = new IdentityAssessor();
        clone.id = this.id;
        clone.season = this.season && this.season.clone();
        clone.userEmail = this.userEmail;
        clone.user = cloneUser && this.user && this.user.clone();

        if (this.teams) {
            clone.teams = this.teams.map((t: IdentityTeam) => t.clone());
        }

        return clone;
    }

    /**
     * Serialize to a json api format
     * @returns {string}
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'assessor';
        json.data.id = this.id;
        json.data.attributes = { userEmail: this.userEmail };
        json.data.relationships = {};

        if (this.season) {
            json.data.relationships.season = {
                data: { type: 'season', id: this.season.id },
            };
        }

        if (this.user) {
            json.data.relationships.user = {
                data: { type: 'user', id: this.user.id },
            };
        }

        return JSON.stringify(json);
    }

    /**
     * Deserialize from json api format
     */
    public deserialize(json: any, included: any[] = null, user: IdentityUser = null): IdentityAssessor {
        const data: any = json.data || json;
        const attrs: any = data.attributes || {};
        const relationships: any = data.relationships || {};
        included = included || json.included || [];

        this.id = data.id;
        this.season = new IdentitySeason(attrs.seasonId);
        this.userEmail = attrs.userEmail;

        const season: any = included.find((i: any) => i.type === 'season' && i.id === attrs.seasonId);
        if (season) {
            this.season = (new IdentitySeason()).deserialize(season, included);
        }

        const teamLinks: any = relationships.teams;
        if (teamLinks && teamLinks.data) {
            this.teams = [];

            for (const teamLink of teamLinks.data) {
                const identityTeam: any = included.filter((i: any) => i.id === teamLink.id)[0];
                if (identityTeam) {
                    this.teams.push((new IdentityTeam()).deserialize(identityTeam, included, ''));
                }
            }
        }

        // Fill user from relationships if it exists
        if (user) {
            // This will prevent an infinite loop when we deserialize assessors from the user object
            this.user = user;
        } else if (attrs.userId) {
            const includedUser: any = included.filter((i: any) => i.type === 'user' && i.id === attrs.userId)[0];

            if (includedUser) {
                this.user = (new IdentityUser(attrs.userId)).deserialize(includedUser, included);
            } else {
                this.user = new IdentityUser(attrs.userId);
            }
        }

        return this;
    }
}
